import { render, staticRenderFns } from "./DragonBoatConfig.vue?vue&type=template&id=9c1f19fc&scoped=true&"
import script from "./DragonBoatConfig.vue?vue&type=script&lang=js&"
export * from "./DragonBoatConfig.vue?vue&type=script&lang=js&"
import style0 from "./DragonBoatConfig.vue?vue&type=style&index=0&id=9c1f19fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1f19fc",
  null
  
)

export default component.exports